import { lazy } from 'react';

const CheckVoucher = lazy(() => import('../pages/CheckVoucher'));
const CheckVoucherPrintPreview = lazy(() =>
  import('../pages/CheckVoucher/Screens/CheckVoucherPrintPreviewScreen'),
);

const checkVoucherRoute = {
  public: [],
  auth: [
    // Must stay ahead of the `:status?` route below — otherwise the tab route
    // swallows this path as a tab name.
    {
      name: 'check_voucher_print_preview',
      path: '/finance-and-accounting/check-voucher/print-preview',
      component: CheckVoucherPrintPreview,
    },
    {
      name: 'check_voucher',
      path: '/finance-and-accounting/check-voucher/:status?',
      component: CheckVoucher,
    },
  ],
};

export default checkVoucherRoute;
